import { ApiError, ApiErrorCode } from 'src/error/ApiError';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { CreateUserFormValues } from '../components/CreateUserForm';

type FormHandle = {
  reset: () => void;
  setFieldError: (path: string, error: string) => void;
};

export function useHandleCreateUser(form: FormHandle, onSuccess: () => void) {
  return async (createFn: () => Promise<unknown>, userData: CreateUserFormValues) => {
    try {
      await createFn();
      Mixpanel.track(MixpanelEvents.USER_CREATED);
      form.reset();
      onSuccess();
    } catch (e) {
      if (ApiError.isApiError(ApiErrorCode.DUPLICATE_EMAIL, e)) {
        form.setFieldError('emailAddress', e.message);
      }
      notifyAndLogError(
        'Failed to create user',
        'An error occurred while creating the user. Please try again.',
        e,
        { userData },
      );
    }
  };
}
